// import React, { useEffect, useState } from "react";
// import AddUserForm from "./AddUserForm";
// import { useSelector } from "react-redux";
// import type { RootState } from "../../../store/store";
// import SubadminAddUserForm from "../../Subadmin/SubadminAddUserForm";
// import { apiDeleteUser, getAllUsers } from "../../../utils/api";
// import { toast } from "react-toastify";
// import UserReport from "./UserReport";

// interface User {
//     _id: string;
//     username: string;
//     email: string;
//     userType: "user" | "subadmin";
//     employeeId: string;
//     profilePicture: string | null;
//     designation: string;
//     createdAt: { $date: string };
//     updatedAt: { $date: string };
//     __v: number;
// }

// const UserList: React.FC = () => {
//     const colors = ["bg-red-500", "bg-blue-500", "bg-green-500", "bg-yellow-500"];

//     const [userToDelete, setUserToDelete] = useState<User | null>(null);
//     const [selectedUser, setSelectedUser] = useState<User | null>(null);
//     const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
//     const [userData, setUserData] = useState<User[]>([]);
//     const [refresh, setRefresh] = useState(false);


//     const { user } = useSelector((state: RootState) => state.auth);

//     // 🟦 FETCH USERS
//     useEffect(() => {
//         const fetchUsers = async () => {
//             try {
//                 const res = await getAllUsers();

//                 const cleanUsers = res.data.map((u: { _id: string; username: string; email: string; userType: string; department?: string }) => ({
//                     ...u,
//                     _id: u._id   // _id is already a string from backend
//                 }));

//                 setUserData(cleanUsers);
//                 console.log(cleanUsers, "Cleaned Fetched Users Data");
//             } catch {
//                 console.error("Error fetching user data");
//             }
//         };
//         fetchUsers();
//     }, [userToDelete, refresh]);


//     // 🟥 DELETE HANDLERS
//     const handleDeleteClick = (user: User) => {
//         setUserToDelete(user);
//         setShowDeleteModal(true);
//     };

//     const handleConfirmDelete = async () => {
//         if (userToDelete) {
//             try {
//                 await apiDeleteUser(userToDelete._id);
//                 toast.success(`User ${userToDelete.username} deleted successfully`);
//                 setUserToDelete(null);
//                 setShowDeleteModal(false);

//                 // ✅ AUTO REFRESH USER LIST
//                 setRefresh(prev => !prev);

//             } catch {
//                 toast.error("Error deleting user");
//             }
//         }
//     };


//     const handleCancelDelete = () => {
//         setShowDeleteModal(false);
//         setUserToDelete(null);
//     };

//     return (
//         <div>
//             {user.userType === "admin" ? (
//                 <AddUserForm onUserCreated={() => setRefresh(prev => !prev)} />
//             ) : (
//                 <SubadminAddUserForm onUserCreated={() => setRefresh(prev => !prev)} />
//             )}
//             <hr />
//             <div>
//                 <h1 className="text-lg font-bold">User List</h1>
//                 <div className="p-4 min-h-screen">
//                     {/* 🟢 MOBILE CARD VIEW */}
//                     <div className="md:hidden space-y-4">
//                         {userData.map((user) => (
//                             <div
//                                 key={user._id}
//                                 className="bg-white dark:bg-zinc-800 dark:text-white p-4 rounded-lg shadow-md"
//                             >
//                                 <div className="text-sm text-gray-700">
//                                     <div className="flex border-b pb-2">
//                                         <span className="font-semibold text-gray-500 dark:text-gray-300 w-32 flex-shrink-0 text-start">
//                                             Username:
//                                         </span>
//                                         <span className="truncate dark:text-white">
//                                             {user.username}
//                                         </span>
//                                     </div>
//                                     <div className="flex border-b py-2">
//                                         <span className="font-semibold text-gray-500 dark:text-gray-300 w-32 flex-shrink-0 text-start">
//                                             Email:
//                                         </span>
//                                         <span className="truncate dark:text-white">
//                                             {user.email}
//                                         </span>
//                                     </div>
//                                     <div className="flex border-b py-2">
//                                         <span className="font-semibold text-gray-500 dark:text-gray-300 w-32 flex-shrink-0 text-start">
//                                             User Type:
//                                         </span>
//                                         <span className="text-black dark:text-white uppercase font-semibold">
//                                             {user.userType}
//                                         </span>
//                                     </div>
//                                     <div className="flex border-b py-2">
//                                         <span className="font-semibold text-gray-500 dark:text-gray-300 w-32 flex-shrink-0 text-start">
//                                             Employee ID:
//                                         </span>
//                                         <span className="text-black dark:text-white">
//                                             {user.employeeId}
//                                         </span>
//                                     </div>
//                                     <div className="flex pt-2">
//                                         <span className="font-semibold text-gray-500 dark:text-gray-300 w-32 flex-shrink-0 text-start">
//                                             Designation:
//                                         </span>
//                                         <span className="text-black dark:text-white italic font-light">
//                                             {user.designation}
//                                         </span>
//                                     </div>

//                                     {/* ACTION BUTTONS */}
//                                     <div className="mt-4 pt-4 border-t flex gap-2 justify-between">
//                                         <button
//                                             onClick={() => setSelectedUser(user)}
//                                             className="w-full bg-blue-600 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 transition-colors cursor-pointer"
//                                         >
//                                             View Report
//                                         </button>
//                                         <button
//                                             onClick={() => handleDeleteClick(user)}
//                                             className="w-full bg-red-600 text-white font-bold py-2 px-4 rounded hover:bg-red-700 transition-colors cursor-pointer"
//                                         >
//                                             Delete
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     {/* 🖥 DESKTOP TABLE VIEW */}
//                     <div className="hidden md:block overflow-x-auto shadow-md rounded-lg">
//                         <table className="min-w-full bg-white dark:bg-zinc-800 table-auto">
//                             <thead>
//                                 <tr className="bg-gray-200 dark:bg-zinc-900 text-gray-600 dark:text-white uppercase text-sm leading-normal">
//                                     <th className="py-3 px-6 text-left">User</th>
//                                     <th className="py-3 px-6 text-left">Email</th>
//                                     <th className="py-3 px-6 text-left">User Type</th>
//                                     <th className="py-3 px-6 text-left">Employee ID</th>
//                                     <th className="py-3 px-6 text-left">Designation</th>
//                                     <th className="py-3 px-6 text-end">Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody className="text-gray-600 dark:text-white text-sm font-light">
//                                 {userData.map((user) => (
//                                     <tr
//                                         key={user._id}
//                                         className="border-b border-gray-200 hover:bg-gray-100 dark:hover:bg-zinc-600"
//                                     >
//                                         <td className="py-3 px-6 text-left whitespace-nowrap">
//                                             <div className="flex items-center">
//                                                 {user.profilePicture ? (
//                                                     <img
//                                                         src={user.profilePicture}
//                                                         alt={user.username}
//                                                         className="w-10 h-10 rounded-full object-cover mr-2"
//                                                     />
//                                                 ) : (
//                                                     <div
//                                                         className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold mr-2 ${colors[Math.floor(Math.random() * colors.length)]
//                                                             }`}
//                                                     >
//                                                         {user.username.charAt(0).toUpperCase()}
//                                                     </div>
//                                                 )}
//                                                 <span className="font-semibold capitalize text-lg">
//                                                     {user.username}
//                                                 </span>
//                                             </div>
//                                         </td>
//                                         <td className="py-3 px-6 text-left font-semibold">
//                                             {user.email}
//                                         </td>
//                                         <td className="py-3 px-6 text-left uppercase text-xs font-bold">
//                                             {user.userType}
//                                         </td>
//                                         <td className="py-3 px-6 text-left text-sm font-semibold text-black dark:text-gray-300">
//                                             {user.employeeId}
//                                         </td>
//                                         <td className="py-3 px-6 text-left italic font-semibold">
//                                             {user.designation}
//                                         </td>
//                                         <td className="py-3 px-6 text-center flex gap-4 justify-end items-center">
//                                             <button
//                                                 onClick={() => setSelectedUser(user)}
//                                                 className="bg-blue-600 text-white font-bold py-1 px-3 rounded text-xs hover:bg-blue-700 transition-colors cursor-pointer"
//                                             >
//                                                 View Report
//                                             </button>
//                                             <button
//                                                 onClick={() => handleDeleteClick(user)}
//                                                 className="bg-red-600 text-white font-bold py-1 px-3 rounded text-xs hover:bg-red-700 transition-colors cursor-pointer"
//                                             >
//                                                 Delete
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* 🟡 DELETE CONFIRMATION MODAL */}
//                     {showDeleteModal && userToDelete && (
//                         <div className="fixed inset-0 flex items-center justify-center p-4 backdrop-filter backdrop-blur-md z-50">
//                             <div className="bg-red-100 p-6 rounded-lg shadow-xl max-w-sm w-full">
//                                 <h3 className="text-xl font-bold text-red-600 mb-4">
//                                     Confirm Deletion
//                                 </h3>
//                                 <p className="mb-4 text-gray-700">
//                                     Are you sure you want to delete user{" "}
//                                     <strong>{userToDelete.username}</strong>? This action cannot
//                                     be undone.
//                                 </p>
//                                 <div className="flex justify-end gap-2">
//                                     <button
//                                         onClick={handleCancelDelete}
//                                         className="bg-white text-gray-800 font-bold py-2 px-4 rounded hover:bg-gray-100 transition-colors cursor-pointer"
//                                     >
//                                         Cancel
//                                     </button>
//                                     <button
//                                         onClick={handleConfirmDelete}
//                                         className="bg-red-600 text-white font-bold py-2 px-4 rounded hover:bg-red-700 transition-colors cursor-pointer"
//                                     >
//                                         Confirm Delete
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {/* 🟢 USER REPORT MODAL */}
//                     {selectedUser && (
//                         <div className="fixed inset-0 flex items-center justify-center p-4 backdrop-filter backdrop-blur-md z-50">
//                             <UserReport
//                                 userId={selectedUser._id}
//                                 username={selectedUser.username}
//                                 employeeId={selectedUser.employeeId}
//                                 email={selectedUser.email}
//                                 profilePicture={selectedUser.profilePicture || ""}
//                                 role={selectedUser.designation}
//                                 onClose={() => setSelectedUser(null)}
//                             />
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default UserList;

import React, { useEffect, useState } from "react";
import AddUserForm from "./AddUserForm";
import { useSelector } from "react-redux";
import type { RootState } from "../../../store/store";
import SubadminAddUserForm from "../../Subadmin/SubadminAddUserForm";
import { apiDeleteUser, getAllUsers } from "../../../utils/api";
import { toast } from "react-toastify";
import UserReport from "./UserReport";
import { FiSearch, FiTrash2, FiEye } from 'react-icons/fi';

interface User {
    _id: string;
    username: string;
    email: string;
    userType: "user" | "subadmin";
    employeeId: string;
    profilePicture: string | null;
    designation: string;
    department?: string;
    createdAt: { $date: string };
    updatedAt: { $date: string };
    __v: number;
}

const UserList: React.FC = () => {
    const [userToDelete, setUserToDelete] = useState<User | null>(null);
    const [selectedUser, setSelectedUser] = useState<User | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [userData, setUserData] = useState<User[]>([]);
    const [refresh, setRefresh] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState<'all' | 'user' | 'subadmin'>('all');

    const { user } = useSelector((state: RootState) => state.auth);

    // 🟦 FETCH USERS
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllUsers();
                const cleanUsers = res.data.map((u: any) => ({
                    ...u,
                    _id: u._id
                }));
                setUserData(cleanUsers);
                console.log(cleanUsers, "Cleaned Fetched Users Data");
            } catch {
                console.error("Error fetching user data");
            }
        };
        fetchUsers();
    }, [userToDelete, refresh]);

    // 🟥 DELETE HANDLERS
    const handleDeleteClick = (user: User) => {
        setUserToDelete(user);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        if (userToDelete) {
            try {
                await apiDeleteUser(userToDelete._id);
                toast.success(`User ${userToDelete.username} deleted successfully`);
                setUserToDelete(null);
                setShowDeleteModal(false);
                setRefresh(prev => !prev);
            } catch {
                toast.error("Error deleting user");
            }
        }
    };

    const handleCancelDelete = () => {
        setShowDeleteModal(false);
        setUserToDelete(null);
    };

    // Filter and Search Logic
    const search = searchTerm.toLowerCase();

    const filteredUsers = userData.filter(user => {
        const matchesSearch =
            user.username?.toLowerCase().includes(search) ||
            user.email?.toLowerCase().includes(search) ||
            user.employeeId?.toLowerCase().includes(search);

        const matchesFilter =
            filterType === "all" || user.userType === filterType;

        return matchesSearch && matchesFilter;
    });

    const getInitials = (name: string) => {
        return name.charAt(0).toUpperCase();
    };

    const colors = ["bg-red-500", "bg-blue-500", "bg-green-500", "bg-yellow-500", "bg-purple-500"];

    return (
        <div className="bg-white dark:bg-zinc-900 min-h-screen">
            {/* Add User Form Section */}
            <div className="p-4 lg:p-6">
                {user.userType === "admin" ? (
                    <AddUserForm onUserCreated={() => setRefresh(prev => !prev)} />
                ) : (
                    <SubadminAddUserForm onUserCreated={() => setRefresh(prev => !prev)} />
                )}
            </div>

            <hr className="border-gray-200 dark:border-zinc-700" />

            {/* User List Section */}
            <div className="p-4 lg:p-6">
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-1">User List</h1>
                    <p className="text-sm text-gray-600 dark:text-gray-400">Manage all users and their permissions</p>
                </div>

                {/* Search and Filter Bar */}
                <div className="bg-white dark:bg-zinc-800 rounded-lg shadow-md border border-gray-200 dark:border-zinc-700 p-4 mb-6">
                    <div className="flex flex-col lg:flex-row gap-4">
                        {/* Search Input */}
                        <div className="flex-1 relative">
                            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            <input
                                type="text"
                                placeholder="Search by name, email, or employee ID..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-zinc-600 rounded-md bg-white dark:bg-zinc-900 text-gray-700 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0A2975] focus:border-transparent"
                            />
                        </div>

                        {/* Filter Buttons */}
                        <div className="flex gap-2">
                            <button
                                onClick={() => setFilterType('all')}
                                className={`px-4 py-2 rounded-md font-semibold text-sm transition-colors ${filterType === 'all'
                                        ? 'bg-[#0A2975] text-white'
                                        : 'bg-gray-200 dark:bg-zinc-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-zinc-600'
                                    }`}
                            >
                                All
                            </button>
                            <button
                                onClick={() => setFilterType('subadmin')}
                                className={`px-4 py-2 rounded-md font-semibold text-sm transition-colors ${filterType === 'subadmin'
                                        ? 'bg-[#0A2975] text-white'
                                        : 'bg-gray-200 dark:bg-zinc-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-zinc-600'
                                    }`}
                            >
                                Sub Admin
                            </button>
                            <button
                                onClick={() => setFilterType('user')}
                                className={`px-4 py-2 rounded-md font-semibold text-sm transition-colors ${filterType === 'user'
                                        ? 'bg-[#0A2975] text-white'
                                        : 'bg-gray-200 dark:bg-zinc-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-zinc-600'
                                    }`}
                            >
                                User
                            </button>
                        </div>
                    </div>
                </div>

                {/* Desktop Table View */}
                <div className="hidden md:block overflow-x-auto shadow-md rounded-lg border border-gray-200 dark:border-zinc-700">
                    <table className="min-w-full bg-white dark:bg-zinc-800 table-auto">
                        <thead>
                            <tr className="bg-gray-100 dark:bg-zinc-900 text-gray-700 dark:text-white uppercase text-xs font-semibold">
                                <th className="py-3 px-6 text-left">User</th>
                                <th className="py-3 px-6 text-left">Email</th>
                                <th className="py-3 px-6 text-left">User Type</th>
                                <th className="py-3 px-6 text-left">Employee ID</th>
                                <th className="py-3 px-6 text-left">Designation</th>
                                <th className="py-3 px-6 text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-700 dark:text-white text-sm">
                            {filteredUsers.map((userData) => (
                                <tr
                                    key={userData._id}
                                    className="border-b border-gray-200 dark:border-zinc-700 hover:bg-gray-50 dark:hover:bg-zinc-700 transition-colors"
                                >
                                    <td className="py-3 px-6 text-left whitespace-nowrap">
                                        <div className="flex items-center gap-3">
                                            {userData.profilePicture ? (
                                                <img
                                                    src={userData.profilePicture}
                                                    alt={userData.username}
                                                    className="w-10 h-10 rounded-full object-cover"
                                                />
                                            ) : (
                                                <div
                                                    className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold ${colors[Math.floor(Math.random() * colors.length)]}`}
                                                >
                                                    {getInitials(userData.username)}
                                                </div>
                                            )}
                                            <span className="font-semibold capitalize">
                                                {userData.username}
                                            </span>
                                        </div>
                                    </td>
                                    <td className="py-3 px-6 text-left">
                                        {userData.email}
                                    </td>
                                    <td className="py-3 px-6 text-left">
                                        <span className={`px-2 py-1 rounded text-xs font-bold uppercase ${userData.userType === 'subadmin'
                                                ? 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200'
                                                : 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200'
                                            }`}>
                                            {userData.userType}
                                        </span>
                                    </td>
                                    <td className="py-3 px-6 text-left font-semibold">
                                        {userData.employeeId}
                                    </td>
                                    <td className="py-3 px-6 text-left italic">
                                        {userData.designation}
                                    </td>
                                    <td className="py-3 px-6 text-center">
                                        <div className="flex gap-2 justify-center">
                                            <button
                                                onClick={() => setSelectedUser(userData)}
                                                className="bg-[#0A2975] hover:bg-blue-800 text-white font-semibold py-1 px-3 rounded text-xs transition-colors flex items-center gap-1"
                                            >
                                                <FiEye />
                                                View
                                            </button>
                                            <button
                                                onClick={() => handleDeleteClick(userData)}
                                                className="bg-red-600 hover:bg-red-700 text-white font-semibold py-1 px-3 rounded text-xs transition-colors flex items-center gap-1"
                                            >
                                                <FiTrash2 />
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Mobile Card View */}
                <div className="md:hidden space-y-4">
                    {filteredUsers.map((userData) => (
                        <div
                            key={userData._id}
                            className="bg-white dark:bg-zinc-800 p-4 rounded-lg shadow-md border border-gray-200 dark:border-zinc-700"
                        >
                            <div className="flex items-center gap-3 mb-3">
                                {userData.profilePicture ? (
                                    <img
                                        src={userData.profilePicture}
                                        alt={userData.username}
                                        className="w-12 h-12 rounded-full object-cover"
                                    />
                                ) : (
                                    <div
                                        className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg ${colors[Math.floor(Math.random() * colors.length)]}`}
                                    >
                                        {getInitials(userData.username)}
                                    </div>
                                )}
                                <div className="flex-1">
                                    <h3 className="font-semibold text-gray-800 dark:text-white capitalize">{userData.username}</h3>
                                    <span className={`inline-block px-2 py-0.5 rounded text-xs font-bold uppercase mt-1 ${userData.userType === 'subadmin'
                                            ? 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200'
                                            : 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200'
                                        }`}>
                                        {userData.userType}
                                    </span>
                                </div>
                            </div>

                            <div className="text-sm space-y-2 mb-4">
                                <div className="flex justify-between border-b border-gray-200 dark:border-zinc-700 pb-2">
                                    <span className="text-gray-500 dark:text-gray-400 font-semibold">Email:</span>
                                    <span className="text-gray-700 dark:text-white truncate ml-2">{userData.email}</span>
                                </div>
                                <div className="flex justify-between border-b border-gray-200 dark:border-zinc-700 pb-2">
                                    <span className="text-gray-500 dark:text-gray-400 font-semibold">Employee ID:</span>
                                    <span className="text-gray-700 dark:text-white font-semibold">{userData.employeeId}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500 dark:text-gray-400 font-semibold">Designation:</span>
                                    <span className="text-gray-700 dark:text-white italic">{userData.designation}</span>
                                </div>
                            </div>

                            <div className="flex gap-2">
                                <button
                                    onClick={() => setSelectedUser(userData)}
                                    className="flex-1 bg-[#0A2975] hover:bg-blue-800 text-white font-semibold py-2 rounded transition-colors flex items-center justify-center gap-2"
                                >
                                    <FiEye />
                                    View Report
                                </button>
                                <button
                                    onClick={() => handleDeleteClick(userData)}
                                    className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold py-2 rounded transition-colors flex items-center justify-center gap-2"
                                >
                                    <FiTrash2 />
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Empty State */}
                {filteredUsers.length === 0 && (
                    <div className="text-center py-12 bg-white dark:bg-zinc-800 rounded-lg shadow-md border border-gray-200 dark:border-zinc-700">
                        <p className="text-gray-500 dark:text-gray-400 text-lg font-semibold">No users found</p>
                        <p className="text-gray-400 dark:text-gray-500 text-sm mt-2">Try adjusting your search or filter</p>
                    </div>
                )}

                {/* Delete Confirmation Modal */}
                {showDeleteModal && userToDelete && (
                    <div className="fixed inset-0 flex items-center justify-center p-4 backdrop-filter backdrop-blur-md bg-black/40 z-50">
                        <div className="bg-white dark:bg-zinc-800 p-6 rounded-lg shadow-xl max-w-md w-full border border-gray-200 dark:border-zinc-700">
                            <h3 className="text-xl font-bold text-red-600 dark:text-red-500 mb-4">
                                Confirm Deletion
                            </h3>
                            <p className="mb-6 text-gray-700 dark:text-gray-300">
                                Are you sure you want to delete user{" "}
                                <strong className="text-gray-900 dark:text-white">{userToDelete.username}</strong>?
                                <br />
                                <span className="text-sm text-red-600 dark:text-red-400">This action cannot be undone.</span>
                            </p>
                            <div className="flex justify-end gap-3">
                                <button
                                    onClick={handleCancelDelete}
                                    className="bg-gray-200 dark:bg-zinc-700 hover:bg-gray-300 dark:hover:bg-zinc-600 text-gray-800 dark:text-white font-semibold py-2 px-6 rounded transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleConfirmDelete}
                                    className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-6 rounded transition-colors"
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* User Report Modal */}
                {selectedUser && (
                    <div className="fixed inset-0 flex items-center justify-center p-4 backdrop-filter backdrop-blur-md bg-black/40 z-50">
                        <UserReport
                            userId={selectedUser._id}
                            username={selectedUser.username}
                            employeeId={selectedUser.employeeId}
                            email={selectedUser.email}
                            profilePicture={selectedUser.profilePicture || ""}
                            role={selectedUser.designation}
                            onClose={() => setSelectedUser(null)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserList;